import * as validators from '@vuelidate/validators';

export const exactLength = (value: string, length: number) => value.length === length;

export const isNameOrSurname = (value: string) => /^[\p{L}\s'-]+$/u.test(value);

export const isIbanFormat = (value: string) => /^[A-Z]{2}[0-9]{2}(?:[ ]?[A-Z0-9]{1,4}){1,7}$/i.test(value);

export const isStrong = (value: string) => {
  const hasLowerCase = /[a-z]/.test(value);
  const hasUpperCase = /[A-Z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSpecialChar = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(value);
  return hasLowerCase && hasUpperCase && hasNumber && hasSpecialChar;
};
